import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import { openPopup } from "../../../../../components/Popup/_components/WrapperPopup";
import PopupFilterVessel from "../../../../../components/Popup/PopupFilterVessel";
import { selectOneSetting } from '../../../../../util/store/selectors';
import { useSelector } from "../../../../../util/store/store";
import { PlanSetting } from "../../../../../util/varibles/userSetting";
import { loginActions } from "../../../../LoginPage/reducer";
import { selectPlan } from '../../../constants';
import { planOpActions } from "../../../reducer";
import styles from './style.module.scss';

const key = PlanSetting.VESSEL_FILTER

const VesselFilter: React.FC = () => {
    const vessels = useSelector(selectPlan.vessels);
    const vesselFilter = useSelector(selectOneSetting(key));
    const dispatch = useDispatch();

    const callUpdate = (valueA: typeof vessels, valueB: typeof vesselFilter) => {
        dispatch(planOpActions.updateVessels(valueA));
        dispatch(loginActions.updateUserSetting([{ [key]: valueB }]));
    }

    const onChange = (data: string[]) => {
        const newVessels = vessels.map(item => ({ ...item, isShow: data.indexOf(item.id) !== -1 }));
        callUpdate(newVessels, data);
    };

    const handleClear = (e: any) => {
        e.stopPropagation();
        callUpdate(vessels.map(item => ({ ...item, isShow: true })), []);
    }

    const handleOpen = () => {
        const div = openPopup(<PopupFilterVessel {...{
            selected: vesselFilter,
            vessels,
            onSave: onChange,
            onClose: () => {
                div.remove();
            }
        }} />)
    }

    let count = useMemo(() => vessels.filter(({ isShow }) => isShow).length, [vessels]);

    if (vesselFilter.length === 0)
        count = 0

    return <div className='bt-ghost h-32' onClick={handleOpen}>
        <Icon className={styles.icon} icon={ICON_NAME.VESSEL} />
        <span className={styles.name}>Vessel filter</span>
        {count > 0 && <span className={styles.clear} onClick={handleClear}>
            <span>{[count, vessels.length].join('/')}</span>
            <Icon className={styles.close} icon={ICON_NAME.CLOSE} size='small' />
        </span>}
    </div>;
}

export default VesselFilter;
